import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { AlertConfigDtoSchema } from '../contracts';

const UpdateAlertsSettingsRequestDtoSchema = z.object({
  facilityId: z.number(),
  items: z.array(
    z.object({
      id: z.number(),
      displayName: z.string(),
      enableDropdown: z.boolean(),
      dropdownName: z.string().nullable(),
      options: z.array(
        z.object({
          allowMultipleResolutions: z.boolean(),
          label: z.string(),
          points: z.number().nonnegative(),
          pointsResetDays: z.number().nonnegative(),
          priority: z.enum(['LOW', 'MEDIUM', 'HIGH']),
          repeatEnabled: z.boolean(),
          resolutions: z.array(
            z.object({ label: z.string(), sortOrder: z.number() })
          ),
          sortOrder: z.number(),
          timeToResolveDays: z.number().nonnegative(),
          repeatAlertPoints: z.number().nonnegative().nullable(),
          repeatFrequencyDays: z.number().nonnegative().nullable(),
        })
      ),
    })
  ),
});

const UpdateAlertsSettingsResponseDtoSchema = z.array(AlertConfigDtoSchema);

export type UpdateAlertsSettingsRequestDto = z.infer<
  typeof UpdateAlertsSettingsRequestDtoSchema
>;
export type UpdateAlertsSettingsResponseDto = z.infer<
  typeof UpdateAlertsSettingsResponseDtoSchema
>;

export const updateAlertsSettings = (
  dto: UpdateAlertsSettingsRequestDto,
  config?: AxiosRequestConfig<UpdateAlertsSettingsRequestDto>
) => {
  const { facilityId, ...data } =
    UpdateAlertsSettingsRequestDtoSchema.parse(dto);

  return api
    .patch(`/facilities/${facilityId}/alert-settings`, data, config)
    .then(responseContract(UpdateAlertsSettingsResponseDtoSchema));
};
